function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'azul': 'rgb(120, 134, 168)','negro': 'rgb(0, 0, 0)','cafe': 'rgb(110, 68, 40)','verde': 'rgb(119, 168, 141)','gris': 'rgb(117, 106, 105)','obscuro': 'rgb(161, 72, 77)','vino': 'rgb(128, 0, 32)','gris-oxford': 'rgb(117, 106, 105)','morado': 'rgb(139, 94, 139)','marino': 'rgb(30, 58, 95)','rosa': 'rgb(224, 130, 123)','rojo': 'rgb(139, 0, 0)','azul-claro': 'rgb(194, 214, 246)','hueso': 'rgb(238, 228, 220)','verde-claro': 'rgb(92, 155, 155)','verde-gris': 'rgb(1, 50, 32)','rojo-medio': 'rgb(234, 74, 89)','gris-claro': 'rgb(218, 211, 211)','azul-medio': 'rgb(93, 184, 230)','azul-obscuro': 'rgb(56, 54, 64)','gris-negro': 'rgb(211, 194, 186)','naranja-negro': 'rgb(255, 148, 82)','gris-obscuro': 'rgb(56, 61, 62)','naranja': 'rgb(78, 61, 35)','olivo': 'rgb(75, 83, 32)','amarillo-marino': 'rgb(255, 235, 59)','azul-negro': 'rgb(124, 179, 242)','rojo-marino': 'rgb(248, 47, 33)','verde-obscuro': 'rgb(46, 70, 71)','cafe-claro': 'rgb(251, 222, 204)','aqua': 'rgb(168, 191, 188)','amarillo': 'rgb(255, 222, 87)','beige': 'rgb(245, 222, 179)','dorado': 'rgb(255, 215, 0)','plata': 'rgb(192, 192, 192)','arena': 'rgb(211, 195, 163)','cafe-combinado': 'rgb(178, 161, 141)','cafe-medio': 'rgb(184, 145, 109)','naranja-claro': 'rgb(247, 167, 108)','blanco-combinado': 'rgb(255, 255, 255)','lila': 'rgb(200, 162, 200)','rojo-combinado': 'rgb(199, 94, 83)','mostaza': 'rgb(255, 219, 88)','blanco': 'rgb(255, 255, 255)','aqua3': 'rgb(127, 255, 212)','gris-jaspe': 'rgb(169, 169, 169)','verde-negro': 'rgb(114, 173, 171)','mostaza-marino': 'rgb(255, 219, 88)','rosa-verde': 'rgb(255, 192, 203)','amarillo-azul': 'rgb(255, 255, 0)','verde-beige': 'rgb(0, 128, 0)','negro-gris': 'rgb(0, 0, 0)','camel': 'rgb(193, 154, 107)','ladrillo': 'rgb(160, 81, 42)','morado-obscuro': 'rgb(93, 20, 81)','teal': 'rgb(162, 185, 194)','cafe-obscuro': 'rgb(75, 46, 43)','rosa-medio': 'rgb(192, 128, 129)','azul-medio': 'rgb(80, 114, 167)','verde-obscuro': 'rgb(27, 77, 62)','marron': 'rgb(167, 56, 50)','amarillo': 'rgb(212, 175, 55)','naranja': 'rgb(255, 140, 0)','menta': 'rgb(181, 217, 197)','cafe-medio': 'rgb(139, 119, 101)','marron': 'rgb(139, 69, 19)','verde-grisaceo': 'rgb(112, 128, 112)','azul-medio': 'rgb(0, 114, 158)','beige-jaspe': 'rgb(228, 224, 207)','vino-jaspe': 'rgb(97, 13, 13)','azul-grafito': 'rgb(88, 98, 102)',};

    this.images = {};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

window.theme.swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  window.theme.swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);
